import { Fragment } from "@wordpress/element";
import { AppWrapper } from "./state";

import MLB_Wins_Main from "./views/mlb-wins-main";
import NFL_Wins_Main from "./views/nfl-wins-main";
import Covid_Fantasy from "./views/covid-fantasy-main";

import "antd/lib/style/index.less";

const parseBlockConfig = (el) => {
    if (!el || !el.getAttribute) {
        return {};
    }
    const raw = el.getAttribute("data-wl-config");
    if (!raw) {
        return {};
    }
    try {
        const parsed = JSON.parse(raw);
        return parsed && typeof parsed === "object" ? parsed : {};
    } catch (e) {
        return {};
    }
};

const MLB_BLOCK_DEFAULTS = {
    show_standings: true,
    show_draft: true,
    show_schedule: false,
    show_insights: false,
    show_live_strip: false,
    show_recaps: false,
};

const NFL_BLOCK_DEFAULTS = {
    show_standings: true,
    show_draft: true,
    expand_teams: true,
    show_schedule: false,
};

const app = document.querySelectorAll(".mlb-wins-league");
const MLB_Wins_App = ({ blockConfig }) => {
    return (
        <AppWrapper blockConfig={blockConfig}>
            <Fragment>
                <MLB_Wins_Main />
            </Fragment>
        </AppWrapper>
    );
};
if (app.length) {
    app.forEach((container) => {
        const blockConfig = {
            ...MLB_BLOCK_DEFAULTS,
            ...parseBlockConfig(container),
        };
        wp.element.render(<MLB_Wins_App blockConfig={blockConfig} />, container);
    });
}

const nfl_app = document.querySelectorAll(".nfl-wins-league");
const NFL_Wins_App = ({ blockConfig }) => {
    return (
        <AppWrapper blockConfig={blockConfig}>
            <Fragment>
                <NFL_Wins_Main />
            </Fragment>
        </AppWrapper>
    );
};
if (nfl_app.length) {
    nfl_app.forEach((container) => {
        const blockConfig = {
            ...NFL_BLOCK_DEFAULTS,
            ...parseBlockConfig(container),
        };
        wp.element.render(<NFL_Wins_App blockConfig={blockConfig} />, container);
    });
}

const covid_app = document.querySelectorAll(".covid-fantasy-baseball");
const Covid_Fantasy_App = () => {
    return (
        <AppWrapper blockConfig={{}}>
            <Fragment>
                <Covid_Fantasy />
            </Fragment>
        </AppWrapper>
    );
};
if (covid_app.length) {
    covid_app.forEach((container) => {
        wp.element.render(<Covid_Fantasy_App />, container);
    });
}
